import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses, DialogProps } from '@paintscout/ui'
import type { LeadSourceResult, LeadSourceType } from '@paintscout/util/builder'
import type { OptionsDocument } from 'paintscout'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputField } from '@paintscout/ui'
import CloseIcon from '@material-ui/icons/Close'
import { updateLeadSource } from '@paintscout/util/builder'

const useStyles = makeStyles<Theme, EditLeadSourceDialogProps>(
  (_theme) => ({
    root: {},
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }),
  { name: 'EditLeadSourceDialog' }
)

export interface EditLeadSourceDialogProps extends DialogProps {
  classes?: StyleClasses<typeof useStyles>
  type: LeadSourceType
  item: LeadSourceResult<LeadSourceType>
  options: OptionsDocument
  isNew?: boolean
  onConfirm: (options: OptionsDocument, isDirty?: boolean) => void
  onCancel: () => void
}

function EditLeadSourceDialog(props: EditLeadSourceDialogProps) {
  const classes = useStyles(props)
  const { item, type, options, loading, isNew, onConfirm, ...otherProps } = props
  const [source, setSource] = useState<LeadSourceResult<LeadSourceType>>(item)
  const [isDirty, setIsDirty] = useState<boolean>(false)

  const handleConfirm = (_: any) => {
    const updatedOptions = updateLeadSource({
      options,
      type,
      source: {
        ...source,
        label: source.label.trim()
      }
    })
    onConfirm(updatedOptions, isDirty)
  }

  const handleChange = (event: any) => {
    const { name, value } = event.target
    setIsDirty(true)
    setSource((source) => {
      return {
        ...source,
        [name]: value
      }
    })
  }

  return (
    <Dialog fullWidth={true} maxWidth={'md'} {...otherProps}>
      <DialogTitle
        classes={{ root: classes.dialogTitle }}
        rightContent={
          <IconButton size="small" onClick={props.onCancel} disabled={loading}>
            <CloseIcon />
          </IconButton>
        }
      >
        {isNew ? 'Add Lead Source' : 'Edit Lead Source'}
      </DialogTitle>
      <DialogContent style={{ padding: '24px 16px 32px 16px' }}>
        <form
          id="area-option"
          onSubmit={(ev) => {
            ev.preventDefault()
            handleConfirm(ev)
          }}
        >
          <Grid item xs={12}>
            <InputField
              classes={{ root: classes.input }}
              label={'Label or Name'}
              name={'label'}
              value={source.label}
              fullWidth={true}
              onChange={handleChange}
              required
              error={!source.label}
            />
          </Grid>
        </form>
      </DialogContent>
      <DialogActions showBorder={true}>
        <Button type="submit" form="area-option" disabled={loading} variant={'contained'}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditLeadSourceDialog
